import { Component, type ReactNode, type ErrorInfo } from "react";
import { RefreshCw } from "lucide-react";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("ErrorBoundary caught:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex flex-col items-center justify-center h-full gap-6 bg-gray-950 text-white">
          <p className="text-2xl text-gray-400">Something went wrong</p>
          <button
            onClick={() => window.location.reload()}
            className="flex items-center gap-2 px-8 py-4 bg-blue-600 rounded-2xl text-xl font-medium active:bg-blue-700 min-h-[64px]"
          >
            <RefreshCw size={24} />
            Tap to reload
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
